export default __webpack_public_path__ + "static/media/RunHorseLight_5_1.54262c46.jpg";